export default `id
documentUri
documentId
status
sentOn
accountBySentTo{
  id
  name
}`
